import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '@cencosud-cencommerce/paris-uikit';

import {
  LABEL_COMMUNE,
  LABEL_REGION
} from '@/sections/address/components/AddressForm/constants';
import { getInputStatus } from '@/sections/address/components/AddressForm/utils';
import type { AddressFormValues } from '@/sections/address/types/AddressFormValues';
import useCommunesOptions from '@/sections/region/hooks/useCommunesOption';
import useRegionsOptions from '@/sections/region/hooks/useRegionsOptions';

export const RegionAndCommune = () => {
  const { control, resetField, trigger, watch, setValue } =
    useFormContext<AddressFormValues>();

  const regionOptions = useRegionsOptions();
  const communeOptions = useCommunesOptions(watch('region'));

  const region = watch('region');
  const commune = watch('commune');
  const streetName = watch('streetName');

  useEffect(() => {
    if (region && commune && streetName) {
      setTimeout(() => {
        trigger('streetName');
      }, 100);
    }
  }, [region, commune, streetName, trigger]);

  return (
    <>
      <Controller
        control={control}
        name="region"
        render={({ field, fieldState, formState }) => (
          <Select
            {...field}
            options={regionOptions}
            label={LABEL_REGION}
            helperText={fieldState.error?.message}
            onChange={(e) => {
              const value = e.target.value;
              field.onChange(value);
              resetField('commune');
              setValue('commune', '');
            }}
            status={getInputStatus(formState, fieldState)}
          />
        )}
      />
      <Controller
        control={control}
        name="commune"
        render={({ field, fieldState, formState }) => (
          <Select
            {...field}
            options={communeOptions}
            label={LABEL_COMMUNE}
            disabled={!watch('region')}
            helperText={fieldState.error?.message}
            status={getInputStatus(formState, fieldState)}
            onChange={(e) => {
              const value = e.target.value;
              field.onChange(value);
            }}
          />
        )}
      />
    </>
  );
};

RegionAndCommune.displayName = 'RegionAndCommune';

export default RegionAndCommune;
